import React from "react"
import AssetAlertsListTableWithData from "./AssetAlertsListTableWithData"
import "./AssetAlertsList.scss"
import PropTypes from "prop-types"

const AssetAlertsList = ({ facilityId }) => (
  <div className="AssetAlertsList">
    <h1>Alerts</h1>
    <hr />
    <div className="content">
      <div className="heading">
        <h2>Location Alerts</h2>
        <h3>Know when an asset enters an area</h3>
      </div>

      <AssetAlertsListTableWithData facilityId={facilityId} />
    </div>
  </div>
)

AssetAlertsList.propTypes = {
  facilityId: PropTypes.string,
}

export default AssetAlertsList
